import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import "../../styles/Admin.css";

const Logistik = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [truckData, setTruckData] = useState([]);
  const [pengirimanList, setPengirimanList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [showModal, setShowModal] = useState(false);
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [driverNama, setDriverNama] = useState("");
  const [selectedTrackingId, setSelectedTrackingId] = useState("");
  const [modalError, setModalError] = useState("");

  const handleProfileClick = () => {
    navigate("/profile");
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    fetchTruckData();
    fetchPengirimanAktif();
  }, []);

  const fetchTruckData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/daftar_truk",
        { withCredentials: true }
      );
      const sortedData = (response.data.truk_list || []).sort(
        (a, b) => a.id - b.id
      );
      setTruckData(sortedData);
    } catch (error) {
      console.error("Error fetching truck data:", error);
      Swal.fire("Error", "Gagal memuat data armada truk.", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchPengirimanAktif = async () => {
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/daftar_pengiriman",
        { withCredentials: true }
      );
      const data = response.data || [];
      const filterSiap = data.filter(
        (p) =>
          p.tracking_id &&
          String(p.status_pengiriman || "").toLowerCase() !== "terkirim" &&
          !String(p.status_pengiriman || "").toLowerCase().includes("batal")
      );
      setPengirimanList(filterSiap);
    } catch (error) {
      console.error("Error fetching pengiriman:", error);
    }
  };

  const handleAddTruck = () => {
    Swal.fire({
      title: "Tambah Armada Truk",
      html: `
        <div class="text-start mt-2">
          <div class="mb-3">
            <label class="fw-semibold text-muted small mb-1">Nomor Plat Truk</label>
            <input type="text" id="plat_nomor" class="form-control rounded-3 font-monospace" placeholder="Contoh: B 1234 ABC">
          </div>
          <div class="mb-2">
            <label class="fw-semibold text-muted small mb-1">Kapasitas Angkut (Kg)</label>
            <input type="number" id="kapasitas_angkut" class="form-control rounded-3" placeholder="Contoh: 8000">
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Simpan Truk",
      cancelButtonText: "Batal",
      confirmButtonColor: "#198754",
      cancelButtonColor: "#6c757d",
      customClass: {
        confirmButton: "rounded-pill px-4 fw-bold",
        cancelButton: "rounded-pill px-4 fw-medium",
      },
      preConfirm: () => {
        const plat_nomor = document.getElementById("plat_nomor").value.trim();
        const kapasitas_angkut = document.getElementById("kapasitas_angkut").value.trim();

        if (!plat_nomor || !kapasitas_angkut) {
          Swal.showValidationMessage("Plat Nomor dan Kapasitas Angkut wajib diisi!");
          return false;
        }

        return {
          truk_list: [
            {
              plat_nomor,
              kapasitas_angkut: Number(kapasitas_angkut),
            },
          ],
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post("https://c-greenproject.org:7500/tambah_truk", result.value, {
            withCredentials: true,
          })
          .then((response) => {
            Swal.fire("Sukses", response.data.message || "Truk berhasil ditambahkan!", "success");
            fetchTruckData();
          })
          .catch((error) => {
            Swal.fire(
              "Error",
              error.response?.data?.error || "Gagal menambahkan truk.",
              "error"
            );
          });
      }
    });
  };

  const handleOpenAssignModal = (truk) => {
    setSelectedTruck(truk);
    setDriverNama("");
    setSelectedTrackingId("");
    setModalError("");
    fetchPengirimanAktif();
    setShowModal(true);
  };

  const handleConfirmAssign = async () => {
    if (!driverNama.trim()) {
      setModalError("Nama Driver wajib diisi!");
      return;
    }

    if (!selectedTrackingId) {
      setModalError("Silakan pilih salah satu Resi / Tracking ID pengiriman!");
      return;
    }

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/pilih_truk_driver",
        {
          truk_id: selectedTruck.id,
          driver_nama: driverNama.trim(),
          tracking_id: selectedTrackingId,
        },
        { withCredentials: true }
      );

      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Driver Berhasil Ditugaskan!",
        html: `
          <div class="text-center mt-2">
            <p class="mb-1 text-muted">Kode Unik Driver:</p>
            <h3 class="fw-bold font-monospace text-success">${response.data.kode_unik || "-"}</h3>
            <small class="text-secondary">Berikan kode unik ini kepada driver untuk proses update logistik.</small>
          </div>
        `,
        confirmButtonColor: "#198754",
        confirmButtonText: "Selesai",
        customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
      });
      fetchTruckData();
    } catch (error) {
      setModalError(error.response?.data?.error || "Gagal menugaskan driver.");
    }
  };

  const totalPages = Math.ceil(truckData.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentTruckData = truckData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Logout error fallback:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const getStatusBadge = (status) => {
    const s = String(status || "Tersedia").toLowerCase().trim();
    if (s.includes("tidak") || s.includes("jalan") || s.includes("kirim") || s.includes("operasi")) {
      return <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 rounded-pill fw-semibold">Beroperasi</span>;
    }
    if (s.includes("rusak") || s.includes("maintenance") || s.includes("batal")) {
      return <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-2 rounded-pill fw-semibold">Perbaikan</span>;
    }
    return <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-2 rounded-pill fw-semibold text-capitalize">{status || "Tersedia"}</span>;
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return "-";
    return Number(num).toLocaleString("id-ID");
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      <style>{`
        .dataTables_paginate,
        .dataTables_info,
        .dataTables_length,
        .dataTables_filter {
          display: none !important;
        }
      `}</style>

      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span
            id="user-role"
            onClick={handleProfileClick}
            style={{ cursor: "pointer" }}
          >
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        <div className="sidebar p-3" style={{ width: "240px", flexShrink: 0 }}>
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" /> {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/logistik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/logistik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/logistik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/logistikp")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/logistikp" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/logistikp" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Shipping" /> Pengiriman
            </div>
            <div
              onClick={() => navigate("/logistikrp")}
              className={`list-group-item text-decoration-none ${
                location.pathname.includes("/logistikrp") ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname.includes("/logistikrp") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/panen.png" alt="Harvest" /> Rencana Panen
            </div>
          </div>
        </div>

        <div className="main-content flex-grow-1 p-4" style={{ width: "calc(100% - 240px)", overflowX: "hidden" }}>
          <h1 className="fw-bold text-dark mb-1">Beranda Logistik</h1>
          <p className="text-muted small mb-0">Pantau aktivitas armada dan operasional logistik secara terpusat.</p>
          <div className="divider mb-4 mt-2"></div>

          <div className="row g-4 dashboard-cards mb-4">
            <div className="col-md-4" onClick={() => navigate("/logistikp")} style={{ cursor: "pointer" }}>
              <div className="dashboard-card danger">
                <div className="card-icon">
                  <img src="/static/shipping.png" alt="Total Pengiriman" />
                </div>
                <div className="card-content">
                  <h2>{truckData.reduce((sum, t) => sum + (t.pengiriman_count || 0), 0)}</h2>
                  <p>Total Pengiriman</p>
                </div>
              </div>
            </div>

            <div className="col-md-4" onClick={() => navigate("/logistikrp")} style={{ cursor: "pointer" }}>
              <div className="dashboard-card success">
                <div className="card-icon">
                  <img src="/static/deliver.png" alt="Total Permintaan" />
                </div>
                <div className="card-content">
                  <h2>{truckData.reduce((sum, t) => sum + (t.permintaan_count || 0), 0)}</h2>
                  <p>Total Permintaan</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="dashboard-card primary" style={{ background: "linear-gradient(135deg, #0d9488, #0f766e)" }}>
                <div className="card-icon">
                  <img src="/static/deliver.png" alt="Jumlah Truk" />
                </div>
                <div className="card-content">
                  <h2>{truckData.length}</h2>
                  <p>Jumlah Armada Truk</p>
                </div>
              </div>
            </div>
          </div>

          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h4 className="fw-bold text-success mb-1">Daftar Armada Truk</h4>
                <span className="text-muted small">Kelola data kendaraan dan penugasan driver.</span>
              </div>
              <button className="btn btn-success rounded-pill px-4 shadow-sm fw-medium" onClick={handleAddTruck}>
                <i className="fa fa-plus me-2"></i>Tambahkan Truk
              </button>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data armada truk...</p>
              </div>
            ) : currentTruckData && currentTruckData.length > 0 ? (
              <>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <table className="table table-hover align-middle mb-0" style={{ minWidth: "900px" }}>
                    <thead className="table-light text-nowrap">
                      <tr>
                        <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>ID</th>
                        <th className="py-3 px-3" style={{ width: "160px" }}>Plat Nomor</th>
                        <th className="text-center py-3" style={{ width: "130px" }}>Status</th>
                        <th className="text-end py-3 px-3" style={{ width: "160px" }}>Kapasitas Angkut</th>
                        <th className="py-3 px-3" style={{ width: "180px" }}>Nama Driver</th>
                        <th className="text-center py-3" style={{ width: "140px" }}>Kode Driver</th>
                        <th className="text-center py-3" style={{ width: "120px", borderTopRightRadius: "10px" }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTruckData.map((item, index) => {
                        const isAvailable = !item.driver_nama && (!item.status || item.status === "tersedia");

                        return (
                          <tr key={`truk-${item.id || index}`}>
                            <td className="text-center font-monospace fw-bold text-secondary">
                              #{item.id}
                            </td>
                            <td className="font-monospace fw-bold text-dark px-3">
                              <span className="badge bg-light text-dark border px-2 py-1 fs-6">
                                {item.plat_nomor || "-"}
                              </span>
                            </td>
                            <td className="text-center">
                              {getStatusBadge(item.status)}
                            </td>
                            <td className="text-end font-monospace text-dark px-3 fw-semibold">
                              {formatNumber(item.kapasitas_angkut)} kg
                            </td>
                            <td className="fw-semibold text-dark text-capitalize px-3">
                              {item.driver_nama || <span className="text-muted fst-italic">Belum Ditugaskan</span>}
                            </td>
                            <td className="text-center font-monospace text-muted">
                              {item.kode || item.kode_unik || "-"}
                            </td>
                            <td className="text-center">
                              {isAvailable ? (
                                <button
                                  className="btn btn-sm rounded-pill px-3 fw-semibold shadow-sm"
                                  style={{
                                    color: "#d97706",
                                    borderColor: "#d97706",
                                    backgroundColor: "#ffffff",
                                    borderWidth: "1.5px",
                                    borderStyle: "solid",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "#d97706";
                                    e.currentTarget.style.color = "#ffffff";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "#ffffff";
                                    e.currentTarget.style.color = "#d97706";
                                  }}
                                  onClick={() => handleOpenAssignModal(item)}
                                >
                                  Tugaskan
                                </button>
                              ) : (
                                <span className="text-muted small">—</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {totalPages > 1 && (
                  <nav className="mt-4">
                    <ul className="pagination justify-content-end mb-0">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-start-pill"
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          key={`page-trk-${index + 1}`}
                          className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                        >
                          <button
                            className="page-link shadow-none"
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-end-pill"
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-truck mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Data Truk</h5>
                <p className="mb-0">Silakan tambahkan armada truk baru untuk operasional logistik.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow rounded-4 overflow-hidden">
              <div className="modal-header bg-light border-bottom px-4 py-3">
                <div>
                  <h5 className="modal-title fw-bold text-dark mb-0">Tugaskan Driver ke Truk</h5>
                  <span className="badge bg-secondary-subtle text-secondary font-monospace mt-1">
                    Plat: {selectedTruck?.plat_nomor} ({formatNumber(selectedTruck?.kapasitas_angkut)} Kg)
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close shadow-none"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body px-4 py-3">
                {modalError && (
                  <div className="alert alert-danger rounded-3 py-2 px-3 mb-3 small fw-medium">
                    ⚠️ {modalError}
                  </div>
                )}

                <div className="mb-3">
                  <label className="fw-semibold text-secondary small mb-1">Nama Driver</label>
                  <input
                    type="text"
                    className="form-control rounded-3"
                    placeholder="Contoh: Budi Santoso"
                    value={driverNama}
                    onChange={(e) => setDriverNama(e.target.value)}
                    autoFocus
                  />
                </div>

                <div className="mb-2">
                  <label className="fw-semibold text-secondary small mb-1">Pilih Resi / Tracking ID Pengiriman</label>
                  {pengirimanList.length > 0 ? (
                    <div className="d-flex flex-column gap-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                      {pengirimanList.map((peng) => {
                        const isSelected = selectedTrackingId === peng.tracking_id;
                        return (
                          <div
                            key={peng.tracking_id}
                            onClick={() => setSelectedTrackingId(peng.tracking_id)}
                            className={`p-2 rounded-3 border d-flex justify-content-between align-items-center ${
                              isSelected
                                ? "border-success bg-success-subtle"
                                : "bg-light"
                            }`}
                            style={{ cursor: "pointer", transition: "0.2s" }}
                          >
                            <div>
                              <span className="font-monospace fw-bold text-dark d-block">
                                {peng.tracking_id}
                              </span>
                              <small className="text-muted" style={{ fontSize: "11px" }}>
                                {peng.nama_petani ? `Petani: ${peng.nama_petani}` : ""} 
                                {peng.pabrik_tujuan ? ` ➔ Pabrik: ${peng.pabrik_tujuan}` : ""}
                              </small>
                            </div>
                            <div>
                              {isSelected ? (
                                <span className="badge bg-success rounded-pill px-3 py-1">Terpilih</span>
                              ) : (
                                <span className="badge bg-white text-secondary border rounded-pill px-3 py-1">Pilih</span>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="text-center py-3 bg-light rounded-3 text-muted small">
                      Tidak ada antrean resi pengiriman aktif yang tersedia saat ini.
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer border-top px-4 py-3">
                <button
                  type="button"
                  className="btn btn-light rounded-pill px-4 fw-medium text-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-success rounded-pill px-4 fw-bold shadow-sm"
                  onClick={handleConfirmAssign}
                  disabled={!selectedTrackingId || !driverNama.trim()}
                >
                  Konfirmasi Penugasan
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Logistik;